/**
 * Getters that just chain,
 * useful for making human-readable code
 */
class ConditionChainers {
  get has(): this {
    return this
  }
  get to(): this {
    return this
  }
  get is(): this {
    return this
  }
  get can(): this {
    return this
  }
  get be(): this {
    return this
  }
  get and(): this {
    return this
  }
}

export { ConditionChainers }
